(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* theme editor: selecting a spec row opens its group */
    if (window.__hcDetailsBound) return;
    window.__hcDetailsBound = true;
    document.addEventListener('shopify:block:select', function (e) {
      var d = e.target && e.target.closest && e.target.closest('.hc-details details[data-hc-details-group]');
      if (d) d.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-film"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bindMedia(root) {
    var media = root.querySelector('[data-hc-film-media]');
    var video = media && media.querySelector('video');
    var toggle = media && media.querySelector('[data-hc-film-toggle]');
    if (!video || !toggle) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.removeAttribute('autoplay');
    video.removeAttribute('controls');
    var userPaused = reduce;
    var inView = false;

    function label() {
      var playing = !video.paused;
      var l = playing ? toggle.getAttribute('data-label-pause') : toggle.getAttribute('data-label-play');
      if (l) toggle.setAttribute('aria-label', l);
      media.classList.toggle('is-playing', playing);
      media.classList.toggle('is-poster', !playing && !media.classList.contains('is-started'));
    }
    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { label(); });
    }
    video.addEventListener('playing', function () { media.classList.add('is-started'); label(); });
    video.addEventListener('pause', label);
    toggle.addEventListener('click', function () {
      if (video.paused) { userPaused = false; play(); }
      else { userPaused = true; video.pause(); }
    });

    if (reduce) {
      media.classList.add('is-poster');
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          if (inView && !userPaused) play();
          else if (!inView && !video.paused) video.pause();
        });
      }, { threshold: 0.35 }).observe(media);
    } else {
      play();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !video.paused) video.pause();
      else if (!document.hidden && inView && !userPaused) play();
    });
    label();
  }

  function bindDialog(root) {
    var opener = root.querySelector('[data-hc-film-open]');
    var dialog = root.querySelector('[data-hc-film-dialog]');
    if (!opener || !dialog || typeof dialog.showModal !== 'function') {
      if (opener && dialog) opener.addEventListener('click', function () { window.open(dialog.getAttribute('data-embed').replace('autoplay=1', 'autoplay=0'), '_blank', 'noopener'); });
      return;
    }
    var frame = dialog.querySelector('[data-hc-film-frame]');
    var close = dialog.querySelector('[data-hc-film-close]');
    var video = root.querySelector('[data-hc-film-media] video');
    var resumeLoop = false;

    opener.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = dialog.getAttribute('data-embed');
      iframe.title = dialog.getAttribute('data-title') || '';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      iframe.setAttribute('allowfullscreen', '');
      frame.innerHTML = '';
      frame.appendChild(iframe);
      resumeLoop = !!(video && !video.paused);
      if (resumeLoop) video.pause();
      dialog.showModal();
      if (close) close.focus();
    });
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      frame.innerHTML = '';
      if (resumeLoop && video) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      opener.focus();
    });
  }

  function init() {
    document.querySelectorAll('[data-hc-film]:not([data-hc-film-bound])').forEach(function (root) {
      root.setAttribute('data-hc-film-bound', '');
      bindMedia(root);
      bindDialog(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (!root || root.hasAttribute('data-hc-bound')) return;
      root.setAttribute('data-hc-bound', '');
      var track = root.querySelector('[data-hc-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hc-slide]'));
      var thumbsWrap = root.querySelector('[data-hc-thumbs]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hc-thumb]'));
      var current = root.querySelector('[data-hc-current]');
      var prev = root.querySelector('[data-hc-prev]');
      var next = root.querySelector('[data-hc-next]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;

      function go(i, smooth) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }

      function setActive(i) {
        if (i === index && thumbs[i] && thumbs[i].classList.contains('is-active')) return;
        index = i;
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (current) current.textContent = String(i + 1);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        // keep the active thumbnail in view without moving the page
        var t = thumbs[i];
        if (t && thumbsWrap) {
          var li = t.parentNode;
          var left = li.offsetLeft - (thumbsWrap.clientWidth - li.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
        }
        // only the visible video plays
        slides.forEach(function (s, k) {
          var v = s.querySelector('video');
          if (!v) return;
          if (k === i && !reduce) {
            v.muted = true;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          setActive(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-hc-thumb'), 10) || 0;
          go(i, true);
          if (window.hcTrack) window.hcTrack('gallery_thumb', { slide: i + 1 });
        });
      });
      if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
      if (next) next.addEventListener('click', function () { go(index + 1, true); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
      });
      window.addEventListener('resize', function () { go(index, false); });

      // theme editor: selecting a slide block shows it
      root.addEventListener('shopify:block:select', function (e) {
        var s = e.target.closest && e.target.closest('[data-hc-slide]');
        if (s) go(parseInt(s.getAttribute('data-index'), 10) || 0, false);
      });

      setActive(0);
    }

    // countdown to a real offer end date set in the theme editor; hidden when blank, invalid or past
    function initCountdown(el) {
      if (!el || el.hasAttribute('data-hc-bound')) return;
      el.setAttribute('data-hc-bound', '');
      var end = Date.parse(el.getAttribute('data-hc-countdown'));
      var out = el.querySelector('[data-hc-countdown-value]');
      if (isNaN(end) || !out) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) { el.hidden = true; return; }
        var m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
        out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(mm) + 'm';
        el.hidden = false;
      }
      tick();
      setInterval(tick, 30000);
    }

    function initAll() {
      document.querySelectorAll('[data-hc-gallery]').forEach(initGallery);
      document.querySelectorAll('[data-hc-countdown]').forEach(initCountdown);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  /* description: clamp on phones with a Read more toggle */
  (function () {
    function bindDesc() {
      document.querySelectorAll('[data-hc-desc]:not([data-bound])').forEach(function (d) {
        d.setAttribute('data-bound', '');
        var t = d.querySelector('.hc-hero__desc-text'), b = d.querySelector('[data-hc-desc-more]');
        function fit() {
          if (d.classList.contains('is-open')) return;
          d.classList.add('is-clamped');
          b.hidden = !(t.scrollHeight > t.clientHeight + 2);
          if (b.hidden) d.classList.remove('is-clamped');
        }
        b.addEventListener('click', function () {
          d.classList.add('is-open'); d.classList.remove('is-clamped');
          b.hidden = true; b.setAttribute('aria-expanded', 'true');
          if (window.hcTrack) window.hcTrack('desc_more');
        });
        fit(); window.addEventListener('resize', fit);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindDesc); else bindDesc();
    document.addEventListener('shopify:section:load', bindDesc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-inside"] && !Shopify.designMode) return;
  try {
    
(function () {
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };

  function bind(root) {
    var markers = root.querySelectorAll('[data-hc-inside-marker]');
    var rows = root.querySelectorAll('[data-hc-inside-row]');
    if (!markers.length) return;

    function activate(id) {
      markers.forEach(function (m) {
        var on = m.getAttribute('data-hc-inside-marker') === id;
        m.classList.toggle('is-active', on);
        m.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      var idx = 0;
      rows.forEach(function (r, n) {
        var on = r.getAttribute('data-hc-inside-row') === id;
        r.classList.toggle('is-active', on);
        if (on) idx = n;
      });
      current = idx;
      var c = root.querySelector('[data-hc-inside-current]');
      if (c) c.textContent = String(idx + 1);
    }
    var current = 0;
    root.querySelectorAll('[data-hc-inside-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (current + parseInt(b.getAttribute('data-hc-inside-step'), 10) + rows.length) % rows.length;
        activate(rows[n].getAttribute('data-hc-inside-row'));
      });
    });
    /* phones show one caption under the photo, so start on the first marker */
    activate(markers[0].getAttribute('data-hc-inside-marker'));

    markers.forEach(function (m) {
      var id = m.getAttribute('data-hc-inside-marker');
      m.addEventListener('mouseenter', function () { if (desktop.matches) activate(id); });
      m.addEventListener('focus', function () { activate(id); });
      m.addEventListener('click', function () { activate(id); });
    });
    rows.forEach(function (r) {
      var id = r.getAttribute('data-hc-inside-row');
      r.addEventListener('mouseenter', function () { if (desktop.matches) activate(id); });
      r.addEventListener('click', function () { activate(id); });
    });

    /* theme editor: selecting a hotspot block highlights it */
    root.addEventListener('shopify:block:select', function (e) {
      var m = e.target.closest && e.target.closest('[data-hc-inside-marker]');
      if (m) activate(m.getAttribute('data-hc-inside-marker'));
    });
  }

  function init() {
    document.querySelectorAll('[data-hc-inside]:not([data-hc-inside-bound])').forEach(function (root) {
      root.setAttribute('data-hc-inside-bound', '');
      bind(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-modes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(root) {
    if (root.hasAttribute('data-hc-bound')) return;
    root.setAttribute('data-hc-bound', '');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-hc-mode-shot]'));
    var bar = root.querySelector('[data-hc-modes-bar]');
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && tabs.length > 1;
    var ms = (parseInt(root.getAttribute('data-interval'), 10) || 7) * 1000;
    var current = 0;
    var timer = null;
    var inView = false;

    function select(i, opts) {
      opts = opts || {};
      i = (i + tabs.length) % tabs.length;
      var changed = i !== current;
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[n]) {
          panels[n].hidden = !on;
          panels[n].classList.remove('is-entering');
          if (on && changed) { void panels[n].offsetWidth; panels[n].classList.add('is-entering'); }
        }
      });
      shots.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      root.style.setProperty('--hc-modes-i', i);
      root.style.setProperty('--hc-modes-accent', tabs[i].getAttribute('data-accent') || 'var(--hc-glow)');
      current = i;
      if (opts.focus) tabs[i].focus();
      if (opts.user) {
        stop();
        if (changed && window.hcTrack) window.hcTrack('mode_switch', { mode: (tabs[i].textContent || '').replace(/\s+/g, ' ').trim() });
      } else if (auto) {
        schedule();
      }
    }

    function stop() {
      auto = false;
      clearTimeout(timer);
      if (bar) { bar.style.transition = 'none'; bar.style.width = ''; }
      root.setAttribute('data-autoplay', 'false');
    }
    function schedule() {
      clearTimeout(timer);
      if (!auto || !inView) return;
      if (bar) {
        bar.style.transition = 'none';
        bar.style.width = '0';
        void bar.offsetWidth;
        bar.style.transition = 'width ' + ms + 'ms linear';
        bar.style.width = '100%';
      }
      timer = setTimeout(function () { select(current + 1); }, ms);
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { select(n, { user: true }); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, to = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') to = current + 1;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') to = current - 1;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = tabs.length - 1;
        if (to === null) return;
        e.preventDefault();
        select(to, { focus: true, user: true });
      });
    });
    root.addEventListener('focusin', function (e) { if (auto && root.contains(e.target)) stop(); });

    if (auto && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          if (!auto) return;
          if (inView) schedule();
          else { clearTimeout(timer); if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; } }
        });
      }, { threshold: 0.4 }).observe(root);
    } else if (auto) {
      inView = true;
      schedule();
    }

    root.__hcModesSelect = function (el) {
      var n = tabs.indexOf(el);
      if (n > -1) select(n, { user: true });
    };
  }

  function init() {
    document.querySelectorAll('[data-hc-modes]').forEach(bind);
  }

  if (!window.__hcModesEditor) {
    window.__hcModesEditor = true;
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target && e.target.closest && e.target.closest('.hc-modes__tab');
      var root = tab && tab.closest('[data-hc-modes]');
      if (root && root.__hcModesSelect) root.__hcModesSelect(tab);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function bindLoops(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('[data-hc-ugc-loop]'));
    if (!vids.length || reduce || saveData || !('IntersectionObserver' in window)) return;
    function on(v) {
      if (!v.src) v.src = v.getAttribute('data-src');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    vids.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('is-on'); }); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !document.documentElement.classList.contains('hc-ugc-open')) on(en.target);
        else en.target.pause();
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { io.observe(v); });
    root.__hcUgcResume = function () {
      vids.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) on(v);
      });
    };
  }

  function bindPlayer(root) {
    var dialog = root.querySelector('[data-hc-ugc-dialog]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hc-ugc-open]'));
    if (!dialog || !cards.length) return;
    var video = dialog.querySelector('[data-hc-ugc-video]');
    var nameEl = dialog.querySelector('[data-hc-ugc-name]');
    var idx = 0, opener = null;
    var native = typeof dialog.showModal === 'function';

    function show(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      video.poster = c.getAttribute('data-poster') || '';
      video.setAttribute('aria-label', c.getAttribute('aria-label') || c.getAttribute('data-name') || '');
      video.src = c.getAttribute('data-src');
      nameEl.textContent = c.getAttribute('data-name') || '';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      if (window.hcTrack) window.hcTrack('ugc_play', { video_id: c.getAttribute('data-name') || String(idx + 1) });
    }
    function pauseLoops() {
      root.querySelectorAll('[data-hc-ugc-loop]').forEach(function (v) { v.pause(); });
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (!native) { window.open(c.getAttribute('data-src'), '_blank', 'noopener'); return; }
        opener = c;
        document.documentElement.classList.add('hc-ugc-open');
        pauseLoops();
        dialog.showModal();
        show(i);
        dialog.querySelector('[data-hc-ugc-close]').focus({ preventScroll: true });
      });
    });
    dialog.querySelectorAll('[data-hc-ugc-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(idx + Number(b.getAttribute('data-hc-ugc-step'))); });
    });
    dialog.querySelector('[data-hc-ugc-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });
    video.addEventListener('ended', function () { if (idx < cards.length - 1) show(idx + 1); });
    dialog.addEventListener('close', function () {
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.documentElement.classList.remove('hc-ugc-open');
      if (root.__hcUgcResume) root.__hcUgcResume();
      if (opener) opener.focus({ preventScroll: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-hc-ugc]:not([data-hc-ugc-bound])').forEach(function (root) {
      root.setAttribute('data-hc-ugc-bound', '');
      bindLoops(root);
      bindPlayer(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
